export const theme = {
  breakpoint: {
    full: "1400px",
    medium: "600px",
    mobile: "400px"
  }
}